<template>
  <div class="home">
    <Chapter
      v-for="(section, index) in data.sections"
      :content="section"
      :scrollVal="scrollVal"
      :showInfo="showInfo"
      :key="index"
    ></Chapter>
    <transition name="fade">
      <Info :content="data.info" v-if="showInfo"></Info>
    </transition>
    <Menu key="menu" :showInfo="showInfo" :data="data"></Menu>
    <Index
      key="index"
      :sections="data.sections"
      :scrollVal="scrollVal"
      :data="data"
    ></Index>
  </div>
</template>

<script>
import Chapter from "@/components/Chapter.vue";
import Info from "@/components/Info.vue";
import Menu from "@/components/Menu.vue";
import Index from "@/components/Index.vue";

export default {
  name: "home",
  components: { Chapter, Info, Menu, Index },
  props: ["data", "scrollVal", "showInfo"],
};
</script>
